<template>
  <div class="tbe-final-order" id="tbe-final-order">
    <tbe-alert group="finalOrderDetails">
      <template #payload="{ order, customer, product, option, generalSettings, supplierSettings }">
        <div class="tbe-final-order-details">
          <div class="tbe-final-order-details-detail__head">
            <h3>{{ t('FinalOrder.BookingConfirmationTitle') }}</h3>
            <p>{{ t('FinalOrder.BookingConfirmationSubTitle', { email: customer.email }) }}</p>
          </div>
          <ul class="tbe-final-order-details-list">
            <li id="tbe-final-order-detail-product" class="tbe-final-order-details-item">
              <b> {{ t(`FinalOrder.${capitalize(product.type)}`) }}: </b>
              <span>{{ product.title }}</span>
            </li>
            <template v-if="option">
              <li id="tbe-final-order-detail-option" class="tbe-final-order-details-item">
                <b>{{ t(`FinalOrder.${capitalize(product.type)}Option`) }}: </b>
                <span>{{ option.title }}</span>
              </li>
              <li id="tbe-final-order-detail-duration" class="tbe-final-order-details-item">
                <b>Duration: </b>
                <span>
                  {{ option.duration || product.duration }}
                  {{ t('FinalOrder.Min').toLowerCase() }}
                </span>
              </li>
            </template>
            <li id="tbe-final-order-detail-date" class="tbe-final-order-details-item">
              <b>{{ t(`FinalOrder.${capitalize(product.type)}Date`) }}: </b>
              <span>{{ $filters.dateFormat(order.date, 'E, MMM dd, yyyy') }}</span>
            </li>
            <li id="tbe-final-order-detail-start-time" class="tbe-final-order-details-item">
              <b>{{ t('FinalOrder.StartTime') }}: </b>
              <span>{{ order.startTime.time }}</span>
            </li>
            <li id="tbe-final-order-detail-number-people" class="tbe-final-order-details-item">
              <b>{{ t('FinalOrder.NumberPeople') }}: </b>
              <span>{{ order.amountPeople }}</span>
            </li>
            <li id="tbe-final-order-detail-total-price" class="tbe-final-order-details-item">
              <b>{{ t('FinalOrder.Total') }}: </b>
              <span>{{ order.price.total }}</span>
              <span>&nbsp;</span>
              <span>{{ generalSettings.currency.value }}</span>
            </li>
          </ul>
          <div class="tbe-final-order-details-detail__footer">
            <p>
              {{ t('FinalOrder.MeetingPointAdress') }}:<br />
              <a :href="supplierSettings.mp_address" target="_blank">
                <b>{{ supplierSettings.mp_address_label }}</b>
              </a>
            </p>
            <p>
              {{ t('FinalOrder.CustomerSupportHotline') }}:<br />
              <a :href="'tel:' + supplierSettings.mp_phone">
                <b>{{ supplierSettings.mp_phone_label }}</b>
              </a>
              ({{ t('Global.CallsOnly').toLowerCase() }})
            </p>
          </div>
        </div>
      </template>
    </tbe-alert>
  </div>
</template>

<script>
  import { computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import { useI18n } from 'vue-i18n'

  import tbeAlert, { useAlert } from 'common/plugins/rs-alert'
  import { FilterService } from 'common/services'

  export default {
    name: 'tbeFinalOrderView',

    components: { tbeAlert },

    setup() {
      const store = useStore()
      const { t } = useI18n()
      const alert = useAlert()

      const product = computed(() => store.state.booking.product)
      const options = computed(() => store.state.booking.options)
      const order = computed(() => store.state.booking.order)
      const customer = computed(() => store.state.booking.customer)

      const generalSettings = computed(() => store.state.app.generalSettings)
      const supplierSettings = computed(() => store.state.app.supplierSettings)

      const option = computed(() => options.value.find(({ id }) => order.value.optionId === id))

      onMounted(() => {
        alert.add({
          severity: 'success',
          payload: { product, option, order, customer, generalSettings, supplierSettings },
          group: 'finalOrderDetails',
          closable: false
        })

        setTimeout(
          () =>
            document.getElementById('tbe-final-order').scrollIntoView({
              block: 'center',
              behavior: 'smooth'
            }),
          200
        )
      })

      return { t, capitalize: FilterService.capitalize }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-final-order-details {
    h3 {
      font-size: 18px;
      margin-bottom: 5px;
    }

    p {
      font-size: 14px;
      margin-bottom: 10px;
      line-height: 1.4;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    a {
      text-decoration: underline;
      color: #000;
      box-shadow: none;

      &:hover {
        color: #000;
        text-decoration: none;
      }
    }
  }

  .tbe-final-order-details-list {
    margin: 10px 0;
    padding: 0;
    list-style-type: none;
    font-size: 14px;
  }

  .tbe-final-order-details-item {
    margin-bottom: 10px;
    line-height: 1;
  }
</style>
